import React from "react";

import { useIntl } from "react-intl";

import Price from "@mapmycustomers/shared/types/plans/Price";

import formatPrice from "../../util/formatPrice";
import { DescriptionColumn, PriceColumn, Row } from "../BaseRow";

interface Props {
  hasAdjustedPrice: boolean;
  hasProratedPrice: boolean;
  isCurrentPlanTrial: boolean;
  price: Price;
  switchingToAnnual: boolean;
}

const DueTodayRow: React.FC<Props> = ({
  hasAdjustedPrice,
  hasProratedPrice,
  isCurrentPlanTrial,
  price,
  switchingToAnnual,
}) => {
  const intl = useIntl();
  return (
    <Row>
      <DescriptionColumn
        description={
          !isCurrentPlanTrial && !switchingToAnnual
            ? intl.formatMessage(
                {
                  id: "billing.summary.dueToday",
                  defaultMessage:
                    "{hasAdjustedPrice, select, true {Adjusted Total} other {}}{hasAdjustedPrice, select, true {{hasProratedPrice, select, true { + } other {}}} other {}}{hasProratedPrice, select, true {Prorated Price} other {}}",
                  description: "Billing summary line explaining due today",
                },
                {
                  hasAdjustedPrice,
                  hasProratedPrice,
                }
              )
            : undefined
        }
        title={intl.formatMessage({
          id: "billing.summary.dueToday.title",
          defaultMessage: "Due Today",
          description: "Due today summary row on Billing page",
        })}
      />
      <PriceColumn total>{formatPrice(intl, price, 2)}</PriceColumn>
    </Row>
  );
};

export default DueTodayRow;
